// Lightweight event tracking via Supabase page_views (option b: reuse existing table).
// Events are logged with page_path = "event:<name>:<source>" so they can be filtered in the dashboard.

const SUPABASE_URL = "https://aaydcwhckmrrokzsbpha.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFheWRjd2hja21ycm9renNicGhhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1Mjk0ODAsImV4cCI6MjA2NjEwNTQ4MH0.ow25Id-NdWl-kjXkz2I5278OcbpYa-As-q864N9UhjA";

const BOT_PATTERNS =
  /bot|crawl|spider|slurp|bingbot|googlebot|yandex|baidu|duckduck|semrush|ahrefs|mj12|dotbot|petalbot|bytespider|gptbot|chatgpt|facebookexternalhit|twitterbot|linkedinbot|whatsapp|telegrambot|discordbot|applebot/i;

function isBot(): boolean {
  if (typeof navigator === "undefined") return true;
  return BOT_PATTERNS.test(navigator.userAgent);
}

function isSelfExcluded(): boolean {
  try {
    return localStorage.getItem("heilys_no_track") === "1";
  } catch {
    return false;
  }
}

function getSessionId(): string {
  try {
    const stored = sessionStorage.getItem("heilys_session_id");
    if (stored) return stored;
    const id = crypto.randomUUID?.() ?? Math.random().toString(36).slice(2);
    sessionStorage.setItem("heilys_session_id", id);
    return id;
  } catch {
    return "anon";
  }
}

export type EventName = "code_copy" | "affiliate_click" | "seo_variant";

/**
 * Logs an event to the Supabase page_views table using a synthetic page_path.
 * Format: event:<name>:<source> (e.g. "event:code_copy:hero").
 * Silent fail – errors (incl. RLS 401) are swallowed.
 */
export function trackEvent(name: EventName, source: string) {
  if (isBot() || isSelfExcluded()) return;

  const pagePath = `event:${name}:${source}`;

  try {
    fetch(`${SUPABASE_URL}/rest/v1/page_views`, {
      method: "POST",
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        "Content-Type": "application/json",
        Prefer: "return=minimal",
      },
      body: JSON.stringify({
        session_id: getSessionId(),
        page_path: pagePath,
        page_title: typeof document !== "undefined" ? document.title : null,
        referrer: typeof document !== "undefined" ? document.referrer || null : null,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
        screen_width: typeof window !== "undefined" ? window.innerWidth : null,
        hostname: "heilys.info",
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // ignore
  }
}
